import { Button, Flex, MediaQuery } from "@mantine/core";
import { useCallback, useMemo, useState } from "react";

import ClikDataInfoForm from "../../../../components/ClikDataInfoForm/ClikDataInfoForm.tsx";
import { ClikDataFormOut } from "../../../../components/ClikDataInfoForm/types.ts";
import { ClikCity, ClikCountry } from "../../../../graphql/generated.ts";
import { ClikDataDetail } from "../../../../types/clikData/clikData.ts";
import { CustomerOption } from "../../../../types/customer.ts";
import { useStyles } from "../CompanyInfo.styles.ts";

interface Props {
  data: ClikDataDetail | null | undefined;
  cities: ClikCity[] | null | undefined;
  countries: ClikCountry[] | null | undefined;
  companies: CustomerOption[] | null | undefined;
  onCancel: () => void;
  onSave: () => void;
  onChange: (value: ClikDataFormOut) => void;
}

export const useEditLimitRequestCompanyInfo = ({
  companies,
  cities,
  countries,
  data,
  onCancel,
  onSave,
  onChange,
}: Props) => {
  const { classes } = useStyles();

  const [valid, setValid] = useState(true);

  const handleValueChange = useCallback(
    (value: ClikDataFormOut) => {
      onChange(value);
    },
    [onChange]
  );

  const handleValidChange = useCallback(
    (isValid: boolean) => {
      setValid(isValid);
    },
    [setValid]
  );

  return useMemo(() => {
    if (!data) {
      return null;
    }
    return (
      <>
        <MediaQuery smallerThan="sm" styles={{ display: "none" }}>
          <Flex gap={20}>
            <Button
              variant="outlineGolden"
              type="reset"
              uppercase
              onClick={onCancel}
            >
              cancel
            </Button>
            <Button
              variant="filledGolden"
              type="submit"
              uppercase
              disabled={!valid}
              onClick={onSave}
            >
              save
            </Button>
          </Flex>
        </MediaQuery>
        <MediaQuery largerThan="sm" styles={{ display: "none" }}>
          <Flex gap={20} className={classes.buttonsWrapper}>
            <Button
              variant="outlineGolden"
              type="reset"
              uppercase
              w="100%"
              onClick={onCancel}
            >
              cancel
            </Button>
            <Button
              variant="filledGolden"
              type="submit"
              uppercase
              w="100%"
              disabled={!valid}
              onClick={onSave}
            >
              save
            </Button>
          </Flex>
        </MediaQuery>
        <ClikDataInfoForm
          showCategorySection={false}
          value={data}
          cities={cities}
          countries={countries}
          companies={companies}
          onValueChange={handleValueChange}
          onValidChange={handleValidChange}
        />
      </>
    );
  }, [
    data,
    onCancel,
    valid,
    onSave,
    classes,
    cities,
    countries,
    companies,
    handleValueChange,
    handleValidChange,
  ]);
};
